export default __webpack_public_path__ + "static/media/barnksforte.123a62c4.png";